import React, { createContext, useState, useEffect, useContext } from 'react';

// Demo credentials
const DEMO_EMAIL = 'user@gmail.com';
const DEMO_PASSWORD = 'password123';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  // Check if user is logged in from localStorage
  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      setCurrentUser(JSON.parse(user));
    }
    setLoading(false);
  }, []);

  // Sign up function - mock implementation
  const signup = async (email, password) => {
    try {
      setError('');
      // For demo, always allow registration
      const user = { email };
      
      // Save to localStorage
      localStorage.setItem('user', JSON.stringify(user));
      setCurrentUser(user);
      
      return user;
    } catch (err) {
      setError('Failed to create an account');
      throw new Error('Failed to create an account');
    }
  };

  // Login function - check against demo credentials
  const login = async (email, password) => {
    try {
      setError('');
      
      // Check credentials
      if (email === DEMO_EMAIL && password === DEMO_PASSWORD) {
        const user = { email };
        
        // Save to localStorage
        localStorage.setItem('user', JSON.stringify(user));
        setCurrentUser(user);
        
        return user;
      } else {
        throw { 
          code: email !== DEMO_EMAIL ? 'auth/user-not-found' : 'auth/wrong-password'
        };
      }
    } catch (err) {
      setError(err.message || 'Failed to sign in');
      throw err;
    }
  };

  // Logout function
  const logout = async () => {
    try {
      setError('');
      localStorage.removeItem('user');
      setCurrentUser(null);
    } catch (err) {
      setError('Failed to log out');
      throw new Error('Failed to log out');
    }
  };

  const value = {
    currentUser,
    signup,
    login,
    logout,
    error
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext; 